var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item",class:{'is-active': _vm.active},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"item-icon"},[_c('i',{staticClass:"fa",class:( _obj = {}, _obj['fa-' + _vm.icon] = true, _obj )})]),_c('div',{staticClass:"item-text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }